<template>
  <div id="modal_popup_campaign" class="modal-popup">
    <div class="modal-popup-content">
      <a @click="showModalPopup('modal_popup_campaign', false)" class="close-button">
        <img src="@/assets/images/cms-mkt/close-button.svg" />
      </a>
      <!-- <div class="d-inline-block container-right"> -->
      <div class="offer-details-wrapper" v-if="this.notification">
        <div class="addRewardLayout border-box flex-wrap flex-xl-nowrap justify-content-center">
          <div class="container-fluid d-flex flex-column align-items-center">
               <div class="container-fluid d-flex flex-column align-items-baseline w-80">
                <small class="text-break">{{ $t("cmsLang.campaignChannelLabel") }}</small>
                <!-- <input type="text" v-model="newCampaign.category" class="formedituser w-100" /> -->
                <div class="radioButtonCustom">
                  <label v-for="(product, index) in channels" :key="index">
                    <input name="channeltype" type="radio" :value="product" 
                      @change="selectCampaignChannel($event.target, product)" :checked="product === newCampaign.channel">
                    {{ $t('cmsLang.channel_' + product) }}</label>
                </div>
              </div>
              <div class="container-fluid d-flex flex-column align-items-baseline w-80">
                <small class="text-break">{{ $t("cmsLang.categoryLabel") }}</small>
                <!-- <input type="text" v-model="newCampaign.category" class="formedituser w-100" /> -->
                <div class="radioButtonCustom">
                  <label v-for="(product, index) in categoriesSelect" :key="index">
                    <input name="categorytype" type="radio" :value="product"
                      @change="selectCampaignCategory($event.target, product)" :checked="product === newCampaign.level">
                    {{ $t('cmsLang.campaignCategory_' + product) }}</label>
                </div>
              </div>
             
            <div v-for="(entry) in newCampaign.content" :key="entry.language" class="container-fluid d-flex flex-column align-items-center lang-container"  >
              <br />
              <small class="text-break">{{ $t("cmsLang.language_" + entry.language.toUpperCase()) }}</small>
              <div class="row d-flex flex-column align-items-baseline w-80 ">
                <small class="text-break">{{ $t("cmsLang.campaignTitleLabel") }}</small>
                <input type="text" required v-model="entry.title" class="formedituser w-100" maxlength="50"/>
              </div>
              <div v-if="isCampaignPush" class="row d-flex flex-column align-items-baseline w-80">
                <small class="text-break">{{ $t("cmsLang.campaignDescriptionLabel") }}</small>
                <textarea required v-model="entry.body" class="formedituser w-100" maxlength="120" />
              </div>
              <div v-if="isCampaignInbox" class="row d-flex flex-column align-items-baseline w-80">
                <small class="text-break">{{ $t("cmsLang.campaignSummaryLabel") }}</small>
                <input type="text" required v-model="entry.summary" class="formedituser w-100" maxlength="50"/>
                <small class="text-break">{{ $t("cmsLang.campaignDescriptionLabel") }}</small>
                <v-editor
                    id="usage_instructions_en"
                    rows="6"
                    class="form-control-textarea w-100 my-0"
                    v-model="entry.body"
                     :editor-toolbar="customToolbar"
                    :placeholder="$t('cmsLang.campaignHtmlBodyPlaceholder')"
                  />
             <!-- <div class="row d-flex flex-column align-items-baseline w-80"> -->
              <small class="text-break">{{ $t("cmsLang.campaignLinkLabel") }}</small>
              <input type="text" v-model="entry.link" class="formedituser w-100" />

              <div class="uploadImageDiv w-100">
                <div @click="uploadImageClicked('fileInput' + entry.language)" :id="'fileContainer' + entry.language">
                  <div :key="entry.previewImage" >
                    <div v-if="entry.previewImage" class="offer-preview-image"
                    :style="{ 'background-image': `url(${entry.previewImage})` }">
                    </div>

                    <div v-else-if="entry.url_image" class="offer-preview-image  w-100"
                    :style="{ 'background-image': `url(${entry.url_image})` }">
                    </div>
                    <div v-else class="offer-preview-image  w-100"
                    :style="{ 'background-image': `url(${require('@/assets/images/cms-mkt/offer_0.svg')})` }">
                    </div>
                  </div>
                  <br />
                  <!-- <p v-html="$t('cmsLang.imageInfoLabel')"  >                 </p> -->
                  <div :key="entry.imageError" v-if="entry.imageError && entry.imageError.length > 0">
                    <p v-for="(error, index) in entry.imageError" :key="index" class="red">{{ error.description ?
                      error.error_code + " : " +
                      error.description : $t('cmsLang.errorMessage_' + error) }}</p>
                  </div>
                  <!-- <p v-html="$t('cmsLang.imageError')" class="red" v-if="this.imageError"></p> -->
                  <p v-else></p>
                  <div class="row d-flex flex-column align-items-baseline w-80">
                    <strong class="text-break">{{ $t("cmsLang.imageLabel") }}</strong>
                    </div>
                    <!-- <a @click="$refs.fileInput1.click()" class="uploadFile">
                    {{ $t("cmsLang.uploadImageLabel") }}</a> -->
                  <input type="file" @change="uploadFile('fileInput' + entry.language, entry)" :ref="'fileInput' + entry.language" style="display: none"
                  accept=".png, .jpg, .jpeg, .mp4" />
                </div>

                <div class="w-100 text-left">
                  <a @click="resetImage('fileInput' + entry.language, entry)" class="status-background background-will-expire color-darkgrey">Reset</a>
                </div>
              </div>
              <br />

              <!-- </div> -->

            </div>
            </div>
            <br />

            <!-- <div class="row d-flex flex-column align-items-baseline w-80">
              <small class="text-break">{{ $t("cmsLang.rewardLabel") }}</small>
              <input type="number" v-model="newCampaign.upCoins" class="formedituser w-100" onwheel="return false;"/>
            </div> -->
            <div class="container-fluid d-flex flex-row align-items-baseline w-80">
              <div class=" d-flex flex-column justify-content-between w-80">
                <small class="text-break">{{ $t("cmsLang.startDateLabel") }}</small>
                <date-range class="invoices-filter" :noRanges="true" :single="true" :minDateOrder="minDate"
                  :time="newCampaign.start" @close="startDateSelected" />
              </div>
              <div class="d-flex flex-column justify-content-between w-80">
                <small class="text-break">{{ $t("cmsLang.hourLabel") }}</small>
                <multiselect v-model="newCampaign.hour" :options="hoursAvailable" :placeholder="$t('cmsLang.selectLabel')"
                  select-label="" selected-label="" deselect-label="" :multiple=false openDirection="bottom"
                  :limit=1></multiselect>
                </div>
              </div>
              <br v-if="isCampaignInbox"/>
            <div v-if="isCampaignInbox" class="d-flex flex-column justify-content-between w-80">
              <div class=" d-flex flex-column justify-content-between w-80">
              <small class="text-break">{{ $t("cmsLang.endDateLabel") }}</small>
              <date-range class="invoices-filter" :noRanges="true" :single="true" :minDateOrder="minDate"
                :time="newCampaign.end" @close="endDateSelected" />
              </div>
            </div>
            <div class="container-fluid d-flex flex-column align-items-baseline w-80">
              <p v-html="$t('cmsLang.campaignEndDateError')" class="error" v-if="!this.isEndDateValid"></p>
              <p v-else></p>
            </div>
            <br />
              <div class="d-flex flex-column justify-content-between w-80 ">
                <div v-if="this.notification.user_count && this.notification.user_count > 0" class="contact-details-wrapper  lang-container ">
                  <label v-html="$t('cmsLang.beneficiariesTargetLabel', {
                    nr: this.notification.user_count
                  })">
                  </label>
                </div>
                <small class="text-break">{{ $t("cmsLang.beneficiariesTargetFileLabel") }}</small>
              <form
              @submit.prevent="
                {
                return false;
              }
                "
            >
              <b-form-file v-model="fileReceived" ref="file" accept=".xls, .xlsx"
                    :placeholder="$t('finance.uploadFileLabel')" @input="uploadBeneficiariesFile"></b-form-file>
                    
            </form>
            <div class="w-100">
              <a @click="fileReceived = null" class="pointer">Reset file</a>
            </div>
            </div>
            
           <div v-if="this.error" class="row d-flex flex-column align-items-baseline w-80">
            <br />
            <p  v-if="this.error.error_code" class="error">
              {{ this.error.description ? this.error.description : $t('cmsLang.errorMessage_' + this.error.error_code) }}
            </p>
            <p v-else class="error" v-for="(error, index) in this.error" :key="index">
            {{ error.description ? error.description : $t('cmsLang.errorMessage_' + error.error_code) }}
            </p>
            </div>
            
            <div class="row d-flex flex-column align-items-baseline w-80">
              <br />
              <small class="text-break">{{ $t("cmsLang.publishLabel") }}</small>
              <div class="row d-flex flex-row align-items-baseline justify-content-between w-80">
                <a @click="submitNotification()" class="button-all button-blue">
                  {{ $t('cmsLang.saveLabel') }}

                </a>
                <a @click="showModalPopup('modal_popup_confirm', true)" class="button-all button-red">
                  {{ $t('cmsLang.deleteLabel') }}

                </a>
              </div>
            </div>
          </div>
        </div>


      </div>
      <!-- </div> -->
    </div>
    <div id="modal_popup_confirm" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_confirm', false)" class="close-button">
          <img src="@/assets/images/cms-mkt/close-button.svg" />
        </a>
        <br />
        <p>
          {{ $t("cmsLang.confirmDeleteGameMessage") }}
        </p>
        <div class="buttons">
          <a href="#" class="yesButton" @click="deleteGame()">
            {{ $t("cmsLang.notificationsChooseOptionYes") }}
          </a>
          <a href="#" class="noButton" @click="showModalPopup('modal_popup_confirm', false)">
            {{ $t("cmsLang.notificationsChooseOptionNo") }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from "moment";
  import DateRange from "@/components/DateRange.vue";
  import httpServiceCustomer from "@/http/http-play.js";

  import Cookies from "js-cookie";
  import { VueEditor } from "vue2-editor";

  export default {
    name: "NewCampaignPopup",

    props: {
      user: Object,
      notification: Object,
      image: String,
    },
    components: {
      DateRange,
      'v-editor': VueEditor
    },
    data() {
      return {
        selectedCategory: false,
        newCampaign: {
          content: [{
            language: "ro",
            title: "",
            body: "",
            link: "",
            system: ""
          }, {
            language: "en",
            title: "",
            body: "",
            link: "",
            system: ""
          }],
          hour: "09",
          channel: "push",
          start: [],
          level: "",
          filter: "",
        },
        fileReceived: null,
        isAmount: false,
        previewImage: null,
        minDate: moment().toDate(),
        // products: [11, 12, 13, 14, 15],
        hoursAvailable: ["08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20"],
        languages: ["RO", "EN"],
        channels: ["push", "inbox"],
        imageError: null,
        error: null,
        isLoading: false,
        isSelectedAllAffiliates: false,
        customToolbar: [
          [{ 'header': [false, 1, 2, 3, 4, 5, 6,] }],
          ["bold", "italic"],
          [{ align: "left" }, { align: "center" }, { align: "right" }],
          [{ list: "ordered" }, { list: "bullet" }],
          ["link"]]
      }

    },
    methods: {
      selectCampaignLanguage(element, language) {
        this.newCampaign.language = language;
      },
      selectCampaignCategory(element, category) {
        this.newCampaign.level = category;
      },
      selectCampaignChannel(element, channel) {
        this.newCampaign.channel = channel;
      },
      submitNotification() {
        // validare ??
        // construct notification object

        this.error = null;

        if (this.newCampaign.content[0].title === "") {
          this.error = { error_code: "MI3" };
          return;
        }
        if (this.newCampaign.content[0].body === "") {
          this.error = { error_code: "MI6" };
          return;
        }

        if (!this.isEndDateValid) {
          this.error = {
            error_code: "END_DATE",
            description: this.$t('cmsLang.campaignEndDateError')
          };
          return;
        }

        // this.showModalPopup("modal_popup_loading_cms", true);


        let submitNotification = {
          id: this.newCampaign.id,
          system: this.newCampaign.system,
          channel: this.newCampaign.channel,
          level: this.newCampaign.level,
          content: this.newCampaign.content,
          import_file: this.newCampaign.import_file
        }

        if (this.newCampaign.start.length > 0) {
          submitNotification.start = moment(this.newCampaign.start[0]).format('yyyy-MM-DD') + " " + this.newCampaign.hour + ":00";
        }

        if (this.newCampaign.end.length > 0 && this.isCampaignInbox) {
          submitNotification.end = moment(this.newCampaign.end[0]).format('yyyy-MM-DD') + " 23:59";
        }

        if (this.newCampaign.id > 0) {
          this.updateNotification(submitNotification);
        } else {
          this.addNotification(submitNotification);
        }
      },
      updateNotification(notification) {
        this.showModalPopup("modal_popup_loading_cms", false);

        httpServiceCustomer.customerService
          .updateCampaign(
            notification,
            Cookies.get("token")
          )
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              this.$emit("showinfo", "campaignModifiedSuccess", null);
              this.$emit("updatelist");

            } else {
              this.error = { code: response.status };
              this.$emit("showinfo", "", this.error);
            }
            this.showModalPopup("modal_popup_loading_cms", false);
            // this.showModalPopup("modal_popup_info", true);
          })
          .catch((error) => {
            if (error.response) {
              this.error = error.response.data;
            } else {
              this.error = ["undefined"];
            }
            // this.showModalPopup("modal_popup_loading_cms", false);
            this.showModalPopup("modal_popup_info", true);
            this.$emit("showinfo", "", this.error);
          });
      },
      addNotification(notification) {
        this.showModalPopup("modal_popup_loading_cms", false);

        httpServiceCustomer.customerService
          .addNewCampaign(
            notification,
            Cookies.get("token")
          )
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              this.$emit("showinfo", "campaignAddSuccess", null);
              this.$emit("updatelist");

            } else {

              this.error = { code: response.status };
              this.$emit("showinfo", "", this.error);
            }
            this.showModalPopup("modal_popup_loading_cms", false);
            // this.showModalPopup("modal_popup_info", true);
          })
          .catch((error) => {
            if (error.response) {
              this.error = error.response.data;
            } else {
              this.error = ["undefined"];
            }
            this.showModalPopup("modal_popup_loading_cms", false);
            this.$emit("showinfo", "", this.error);
            // this.showModalPopup("modal_popup_info", true);
          });
      },
      deleteGame() {
        this.successMessage = "";
        this.error = null;
        this.showModalPopup("modal_popup_confirm", false);
        this.showModalPopup("modal_popup_loading_cms", true);

        httpServiceCustomer.customerService
          .deleteCampaign(
            this.newCampaign.id,
            Cookies.get("token")
          )
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              this.$emit("showinfo", "campaignDeleteSuccess", null);
              this.$emit("updatelist");
            } else {
              this.error = { code: response.status };
            }
            this.showModalPopup("modal_popup_loading_cms", false);
          })
          .catch((error) => {
            if (error.response) {
              this.error = error.response.data;
            } else {
              this.error = ["undefined"];
            }
            this.showModalPopup("modal_popup_loading_cms", false);
            this.$emit("showinfo", "", error);
          });
      },
      startDateSelected(value) {
        this.newCampaign.start = value;
      },
      endDateSelected(value) {
        this.newCampaign.end = value;
      },
      timeSelected(value) {
        this.newCampaign.time = value;
      },
      
      uploadImageClicked(referenceId) {
        // let inputId = 'fileinput' + language
        this.$refs[referenceId][0].click();
      },
      uploadBeneficiariesFile() {
        let input = this.$refs.file;

        var reader = new FileReader();
        reader.onload = (e) => {
          if (!e) {
            this.newCampaign.import_file = btoa(reader.content);
          } else {
            this.newCampaign.import_file = btoa(e.target.result);
          }
        };
        let file = input.files;
        if (file && file[0]) {
          //For Browsers othe r than IE.
          if (reader.readAsBinaryString) {
            reader.readAsBinaryString(this.fileReceived);
          } else {
            alert("This browser does not support HTML5.");
          }
        }
        if (!this.fileReceived) {
          return;
        }
        // */
      },
      uploadFile(referenceId, text) {
        text.imageError = null;
        this.newCampaign.image = null;
        text.previewImage = null;
        let input = this.$refs[referenceId][0];

        let file = input.files;
        if (file && file[0]) {
          let reader = new FileReader();
          reader.onload = (e) => {
            text.previewImage = e.target.result;
          };

          reader.readAsDataURL(file[0]);
          if (reader.readAsBinaryString) {
            console.log("read as binary string");
          } else {
            alert("This browser does not support HTML5.");
          }

          let readerReward = new FileReader();
          readerReward.onload = (e) => {
            if (!e) {
              this.newCampaign.image = btoa(readerReward.content);
            } else {
              this.newCampaign.image = btoa(e.target.result);
            }
            this.validateFile(file[0].name, text);
          };
          // reader.readAsDataURL(file[0]);
          if (readerReward.readAsBinaryString) {
            readerReward.readAsBinaryString(file[0]);
          } else {
            alert("This browser does not support HTML5.");
          }


        }
      },
      validateFile(name, text) {
        if (this.newCampaign.image) {
          text.imageError = null;
          text.url_image = "";
          text.isLoading = true;
          this.showModalPopup('modal_popup_loading_cms', true);
          httpServiceCustomer.customerService
            .validateImagePlus({
              type: this.newCampaign.channel,
              language: text.language,
              name: name,
              content: this.newCampaign.image
            }, Cookies.get("token"))
            .then(function (response) {
              return response;
            })
            .catch((error) => {
              return error.response;
            })
            .then((response) => {
              if (response.status == 200) {
                text.url_image = response.data.url_image;
                text.previewImage = null;
              } else {
                text.imageError = [response.data];
              }
              text.isLoading = false;
              // $('fileContainer' + text.language).forceUpdate();
              this.showModalPopup('modal_popup_loading_cms', false);
              this.$forceUpdate();
            });
        }
      },
      resetImage(referenceId, text) {
        this.$refs[referenceId][0].value = null;
        text.previewImage = null;
        text.imageError = null;
        this.$forceUpdate();
      },
    },
    computed: {
      isCampaignPush() {
        return this.newCampaign.channel === 'push';
      },
      isCampaignInbox() {
        return this.newCampaign.channel === 'inbox';
      },
      isEndDateValid() {
        return this.newCampaign.end && this.newCampaign.end[0].isSame(moment().startOf('day'), 'd');
      },
      categoriesSelect(){
        if (this.isUserITAdmin(this.user)){
         return ["marketing", "operational"]
        } else {
          return ["marketing"]
        }
      }
    },
    watch: {
      notification: function () {
        this.error = null;
        this.successMessage = "";
        this.fileReceived = null;
        this.newCampaign.id = this.notification.id;
        if (this.notification.id > 0) {
          this.newCampaign.start = this.notification.start ? [moment(new Date(this.notification.start), 'yyyy-MM-dd HH:mm')] : [moment()];
          this.newCampaign.end = this.notification.end ? [moment(new Date(this.notification.end), 'yyyy-MM-dd HH:mm')] : [moment()];
          this.newCampaign.hour = this.notification.start ? moment(new Date(this.notification.start), 'yyyy-MM-dd HH:mm').format('HH') : "09";
          this.newCampaign.level = this.notification.level;
          this.newCampaign.channel = this.notification.channel;
          this.newCampaign.filter = this.notification.filter;
          this.newCampaign.system = this.notification.system;
          this.newCampaign.content = this.notification.content;
        } else {
          this.newCampaign = {
            id: 0,
            level: "marketing",
            hour: "09",
            channel: "push",
            start: [moment()],
            end: [moment()],
            filter: {},
            system: "",
            content: [{
              language: "ro",
              title: "",
              body: "",
              link: "",
            },
            {
              language: "en",
              title: "",
              body: "",
              link: "",
            }],
          }
        }
      },
    },
  };
</script>
<style scoped src="@/assets/styles/mkt-cms.css"></style>
<style scoped>

  .position {
    position: relative;
    left: 227px;
  }

  .lang-container {
    border: 2px solid #fff !important;
    border-radius: 48px !important;
  }

  .contact-details-wrapper {
    justify-content: space-evenly;
    color: #2D3736;
  }

  .close-button {
    right: 30px;
    top: 15px;
  }

  .offer-details-wrapper {
    border-radius: 48px;
    background: #E5E5E5;
    overflow-y: auto;
    height: calc(100vh - 170px) !important;
  }

  small {
    font-family: "Krona One";
    font-weight: 400;
    font-size: 18px;
    text-transform: uppercase;
  }

  .w-80 {
    width: 80%;
  }

  .ql-toolbar.ql-snow {
    border: 2px solid #fff !important;
    border-radius: 48px !important;
  }

  .multiselect {
    border: 1px solid #d8d8d8;
    background: #f1f1f1 !important;
    height: 40px !important;
    /* border-radius: 20px; */

  }

  .multiselect__input {
    font-size: 15px !important;
    /* border-radius: 20px !important; */
  }

  .multiselect__tags {
    border-radius: 40px !important;
    padding: 8px -30px 0 8px !important;
  }

  .error {
    color: red;
    font-size: 16px;
    ;
  }

  .pointer {
    cursor: pointer;
  }
</style>
